export default {
  order: 0,
  name: "Dashboard",
  icon: "dashboard",
  to: "/dashboard/main",
  enabled: true,
};
